var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0938 18.2891C19.7344 16.6875 20.75 14.4609 20.75 12C20.75 7.19531 16.8047 3.25 12 3.25C7.15625 3.25 3.25 7.19531 3.25 12C3.25 14.4609 4.26562 16.6875 5.86719 18.2891C6.41406 16.1406 8.40625 14.5 10.75 14.5H13.25C15.5547 14.5 17.5469 16.1406 18.0938 18.2891ZM16.9609 19.1875V19.2266C16.8047 17.2734 15.2031 15.75 13.25 15.75H10.75C8.75781 15.75 7.15625 17.2734 7 19.2266C8.40625 20.2031 10.125 20.75 12 20.75C13.8359 20.75 15.5547 20.2031 16.9609 19.1875ZM12 22C8.40625 22 5.125 20.125 3.32812 17C1.53125 13.9141 1.53125 10.125 3.32812 7C5.125 3.91406 8.40625 2 12 2C15.5547 2 18.8359 3.91406 20.6328 7C22.4297 10.125 22.4297 13.9141 20.6328 17C18.8359 20.125 15.5547 22 12 22ZM12 12C12.6641 12 13.25 11.6484 13.6016 11.0625C13.9531 10.5156 13.9531 9.77344 13.6016 9.1875C13.25 8.64062 12.6641 8.25 12 8.25C11.2969 8.25 10.7109 8.64062 10.3594 9.1875C10.0078 9.77344 10.0078 10.5156 10.3594 11.0625C10.7109 11.6484 11.2969 12 12 12ZM8.875 10.125C8.875 9.03125 9.46094 8.01562 10.4375 7.42969C11.375 6.88281 12.5859 6.88281 13.5625 7.42969C14.5 8.01562 15.125 9.03125 15.125 10.125C15.125 11.2578 14.5 12.2734 13.5625 12.8594C12.5859 13.4062 11.375 13.4062 10.4375 12.8594C9.46094 12.2734 8.875 11.2578 8.875 10.125Z",
    fill: "#181C218F",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f9175d31b1f0bd9da8e85ed8d19d6fe6.svg";
export { ForwardRef as ReactComponent };